import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const vipGameCommissionState = {
  vipGameCommissionUI: null,
  vipGameCommissionList: null,
  vipGameCommissionEffList: null,
};

export const vipGameCommissionSlice = createSlice({
  name: "vipGameCommission",
  initialState: vipGameCommissionState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    vipGameCommissionUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipGameCommissionUI = action.payload.data;
    },
    vipGameCommissionListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipGameCommissionList = action.payload.data;
    },
    vipGameCommissionEffListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipGameCommissionEffList = action.payload.data ?? {};
    },
    vipGameCommissionPublished: (state) => {
      state.actionsLoading = false;
    },
  },
});
